import { styled } from "styled-components"
import { useRecoilState } from "recoil"
import { useEffect, useState } from "react"
import LogoButton from "./LogoButton"
import useDeviceMode from "../../../hooks/useDeviceMode"
import MenuDesktop from "./MenuDesktop"
import UserMenuDesktop from "./UserMenuDesktop"
import { isMenuExpandedState } from "../../../recoil/common/Header"
import MenuToggleButton from "./MenuToggleButton"
import UserMenuMobile from "./UserMenuMobile"
import MenuMobile from "./MenuMobile"

const Header = () => {
  const deviceMode = useDeviceMode()
  const [isMenuExpanded, setIsMenuExpanded] =
    useRecoilState(isMenuExpandedState)

  const [lastScrollY, setlastScrollY] = useState(0)
  const [isVisible, setIsVisible] = useState(true)

  useEffect(() => {
    const handleScroll = () => {
      let scrollY = window.scrollY

      if (scrollY > lastScrollY) {
        setIsVisible(false)
      } else {
        setIsVisible(true)
      }

      setlastScrollY(scrollY)
    }

    window.addEventListener("wheel", handleScroll)

    return () => {
      window.removeEventListener("wheel", handleScroll)
    }
  }, [lastScrollY])

  return (
    <RelativeDiv>
      <HeaderDiv
        $isVisible={isVisible}
        $expanded={isMenuExpanded}
        onMouseLeave={() => setIsMenuExpanded(false)}
      >
        <HeaderItemContainer>
          {deviceMode === "pc" && (
            <>
              <LogoButton />
              <MenuDesktop />
              <UserMenuDesktop />
            </>
          )}
          {deviceMode === "mobile" && (
            <>
              <MenuToggleButton />
              <LogoButton />
              <UserMenuMobile />
            </>
          )}
        </HeaderItemContainer>
        {deviceMode === "mobile" && isMenuExpanded && <MenuMobile />}
      </HeaderDiv>
    </RelativeDiv>
  )
}

export default Header

const RelativeDiv = styled.div`
  width: 100%;
  height: 0;
  position: relative;
`

const HeaderDiv = styled.div<{
  $isVisible: boolean
  $expanded: boolean
}>`
  height: 60px;
  width: 100%;
  position: fixed;
  background-color: ${(props) =>
    props.$expanded ? "var(--custom-white-smoke)" : "transparent"};
  text-align: center;

  top: 0;
  z-index: 999;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  pointer-events: auto;
  transition: all 0.3s ease;

  ${(props) => !props.$isVisible && "transform: translateY(-100%)"};

  &:hover {
    background-color: var(--custom-white-smoke);
  }

  ${(props) => props.$expanded && "height: 100vh;"};

  @media ${({ theme }) => theme.device.pc} {
    ${(props) => props.$expanded && "height: 300px;"};
  }
`

const HeaderItemContainer = styled.div`
  max-width: 1440px;
  height: 60px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
  box-sizing: border-box;
`
